import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter, useLocation } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { apiPOSTReq } from '../../../Utils/api'
import { ErrorAlert } from '../../Reusable/Alert'
import environment from '../../../environment'
import { Modal } from 'antd'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { Text, Tag } from '../../Reusable/Text'
import PageHeader from '../../Reusable/PageHeader'
import FullScreenModal from '../../Reusable/FullScreenModal'
import { fetchBBHistory, fetchDACAHistory, normalizeAndSortHistory } from '../../../Utils/bankingDataManager'
import { getBPAccountsWithAccess, toCurrency, formatAvailabilitySchedule } from '../../../Utils/util'
import PendingTable from '../Reusable/PendingTable'

// Images
import AccountNameModal from '../Reusable/AccountNameModal'
import ModalClose from '../../../Images/modal-close.png'

const ClearingTransactions = (props) => {
    const [account, setAccount] = useState(null)
    const [accountIndex, setAccountIndex] = useState(0)
    const [type, setType] = useState()
    const [paymentStatus, setPaymentStatus] = useState([])
    const [postedTransfers, setPostedTransfers] = useState([])
    const [showAccountNameModal, setShowAccountNameModal] = useState(false)
    const [loadingPending, setLoadingPending] = useState(true)
    const [fullScreenModalContent, setFullScreenModalContent] = useState(null)
    const [holdInfoList, setHoldInfoList] = useState([])
    const [subtitle, setSubtitle] = useState(null)

    const location = useLocation()
    const daca = location?.state?.daca

    const urlStr = location.search.replace('?', '')
    const mask = (new URLSearchParams(urlStr).get('mask') || '')

    useEffect(() => {
        // if (mask != '') {
        //     fetchData(mask);
        // }
        // else if (location.state && location.state.account) {
        //     console.log('MoreTransactions234', location.state.account, location.state.type, location.state.accountIndex)
        //     setAccount(location.state.account)
        //     setAccountIndex(location.state.accountIndex)
        //     setType(location.state.type)
        //     // setPaymentStatus(location.state.type === 'Canceled' ? ['canceled'] : location.state.type === 'Rejected' ? ['Rejected', 'denied_approval'] : location.state.type === 'Errored' ? ['error'] : [])
        // }
        // setPaymentStatus(['canceled', 'Rejected', 'denied_approval', 'error'])


        var accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
        accounts = accounts || []

        console.log("ClearingTransactions accounts", accounts)
        console.log("ClearingTransactions account", accounts?.find(acc => acc.accountNumber === location.state.accountNumber))

        setAccount(accounts?.find(acc => acc.accountNumber === location.state.accountNumber))

        getHolds()

    }, [])

    // useEffect(() => {
    //     if (account) {
    //         getPending({ pagination: { pageSize: 100, current: 1 } })
    //     }
    // }, [account])

    // const fetchData = async (mask) => {
    //     await fetchAccounts(mask);
    // }

    // const fetchAccounts = async (mask) => {
    //     return new Promise((resolve) => {
    //         apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccounts`, { "BankProvider": environment.bankProvider.crb }, null, (err, resp) => {
    //             try {
    //                 console.log("/bb/getAccounts", err, resp)
    //                 const data = resp
    //                 if (data.result) {
    //                     if (err) throw new Error(err)
    //                     var bbaccounts = data.bbaccounts || []
    //                     if (bbaccounts.length > 0) {
    //                         const maskAccount = bbaccounts.find((item) => item.mask === mask);
    //                         const index = bbaccounts.findIndex((item) => item.mask === mask);
    //                         if (maskAccount != undefined) {
    //                             setAccount(maskAccount)
    //                             setType("Canceled")
    //                             setAccountIndex(index)

    //                         }
    //                     }
    //                     resolve();
    //                 } else {
    //                     throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
    //                 }
    //             } catch (error) {
    //                 console.log("ERRR getAccounts", error, err, resp)
    //                 ErrorAlert({ description: "Error fetching accounts" })
    //             }
    //         })
    //     })
    // }

    // const getPending = (options) => {
    //     console.log('getPending fetchOptions0:', options, paymentStatus, account.accountId)

    //     const body = {
    //         viewBy: "PAYMENT_STATUS",
    //         paymentStatus: paymentStatus,
    //         accountId: account.accountId,
    //         pagination: options.pagination,
    //     }

    //     if (daca) body.DacaBusinessId = account?.businessId

    //     setLoadingPending(true)

    //     if (daca) fetchDACAHistory(body, (err, resp) => {
    //         if (resp) {
    //             console.log('getPending fetchOptions0: resp', resp)
    //             const normalizedHistory = normalizeAndSortHistory(resp)
    //             setPostedTransfers(normalizedHistory.normalizedData)
    //         }
    //         setLoadingPending(false)
    //     })
    //     else fetchBBHistory(body, (err, resp) => {
    //         if (resp) {
    //             console.log('getPending fetchOptions0: resp', resp)
    //             const normalizedHistory = normalizeAndSortHistory(resp)
    //             setPostedTransfers(normalizedHistory.normalizedData)
    //         }
    //         setLoadingPending(false)
    //     })
    // }

    const getHolds = () => {
        setHoldInfoList([])

        const body = {
            accountNumber: location?.state?.accountNumber,
            // railList: ["Ach", "Checks"],
            // sortDirection: "DESC",
            sortFieldName: "ExpiresAt",
        }

        console.log("/bb/getHolds body", body)

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getHolds`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                console.log("/bb/getHolds resp", err, resp)
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)

                    const updatedArray = data?.holdInfoList.map(obj => ({
                        ...obj,
                        objectId: obj.objectId ?? (obj.railId?.replace("payment/", "") || null),
                        type: obj.rail === "Wires" ? "Wire" : obj.rail === "Internal" ? "Account" : obj.rail,
                        hideExpand: obj.rail === "Internal",
                        status: "hold",
                    }));

                    const count = updatedArray.length;
                    const totalAmount = updatedArray.reduce((sum, hold) => sum + (Number(hold.amount) || 0), 0).toFixed(2);

                    setSubtitle(<Text color={props.theme.colors.defaultLightText}>View all pending holds on this account. Funds will be available on their availability date. <Text color={props.theme.colors.defaultLightText} weight="600">{count} hold{count !== 1 ? 's' : ''} totaling ${toCurrency(totalAmount)}</Text></Text>)

                    setHoldInfoList(updatedArray || [])
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getHolds", error, err, resp)
            } finally {
                setLoadingPending(false)
            }
        })
    }

    return (
        <FlexColumn className='main-padding' start>
            {account && <PageHeader
                titleText={<Flex between centerH gap="16px">Clearing <Tag size="14px">{account?.mask} • {account?.nickName || `Business ${account?.accountSubType}`}</Tag></Flex>}
                back
                onBack={() => {
                    daca ? props.history.replace({
                        pathname: '/daca/transactions',
                        state: { accountId: account?.accountId }
                    }) :
                        props.history.replace({
                            pathname: '/banking/accounts',
                            state: { accountNumber: account?.accountNumber }
                        })
                }}
            />}

            <FlexColumn between style={{ width: '100%', paddingBottom: 24 }}>
                <PendingTable
                    // more
                    title={`Account Holds`}
                    subtitle={subtitle}
                    collapsible={false}
                    loadingPending={loadingPending}
                    pendingTransfers={holdInfoList}
                    hideStatus
                    hideDescription
                    showRefId
                    showExpiresAt
                    // setFullScreenModalContent={setFullScreenModalContent}
                    reFetchTransactions={() => { }}
                    amountTitle="Hold Amount"
                    refId
                    custRowKey="holdId"
                />
            </FlexColumn>

            <Modal
                wrapClassName='account-name-modal'
                visible={showAccountNameModal}
                footer={null}
                closable={false}
                maskClosable={true}
                width={776}
                destroyOnClose={true}
                onCancel={() => setShowAccountNameModal(false)}
                closeIcon={<img width='24px' height='24px' src={ModalClose} />}
            >
                <AccountNameModal onCancel={() => setShowAccountNameModal(false)} />
            </Modal>

            {
                fullScreenModalContent &&
                <FullScreenModal
                    onClick={() => { }}
                    content={fullScreenModalContent}
                    onClose={() => setFullScreenModalContent(null)}
                />
            }
        </FlexColumn>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(ClearingTransactions)))